'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormControlStatic = require('react-bootstrap/lib/FormControlStatic');

var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FormControlStatic2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/FormControlStatic.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/FormControlStatic.js
 ** module chunks = 0
 **/